import { render, staticRenderFns } from "./addPagePurInvoice.vue?vue&type=template&id=11c736dd&scoped=true&"
import script from "./addPagePurInvoice.vue?vue&type=script&lang=js&"
export * from "./addPagePurInvoice.vue?vue&type=script&lang=js&"
import style0 from "./addPagePurInvoice.vue?vue&type=style&index=0&id=11c736dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c736dd",
  null
  
)

export default component.exports